<template>
  <div>
    <b-card
      v-if="driverData"
      no-body
      class="px-1 py-1 driver-view__sticky-info"
    >
      <b-row>
        <b-col
          md="12"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="UserIcon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">Name:</span>
            {{ driverData.fullName }}

          </div>
          <div class="d-flex align-items-center">
            <feather-icon
              icon="KeyIcon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">ID:</span>
            {{ driverData.driverId }}
          </div>
          <div class="d-flex align-items-center">
            <feather-icon
              icon="PhoneIcon"
              class="mr-1"
            />
            <span class="font-weight-bold mr-1">Phone Number:</span>
            {{ driverData.phoneNumber }}
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <b-spinner
              v-if="fetchingLicenses"
              small
              variant="primary"
            />
            <span
              v-else
              :class="`text-${isLicensed ? 'success' : 'danger'}`"
            >
              {{ isLicensed ? 'Licensed' : 'Not Licensed' }}
            </span>
          </div>

          <div
            v-if="viewdIn"
            md="1"
          >
            <b-button
              class="btn-icon rounded-circle ml-1"
              variant="flat-primary"
              @click="$emit(`refetch-${viewdIn}`)"
            >
              <feather-icon
                icon="RefreshCwIcon"
              />
            </b-button>
          </div>
        </b-col>
        <b-col
          md="12"
          class="mt-1"
        >
          <b-button
            v-if="$can('write', 'notifications')"
            class="mr-2"
            size="sm"
            variant="primary"
            @click="openSendNotificationModal"
          >
            Send Notification
          </b-button>
          <b-button
            v-if="$can('write', 'driver-inactivations')"
            size="sm"
            class="mr-2"
            variant="danger"
            @click="openSendAlertModal"
          >
            Send Alert
          </b-button>
          <b-button
            size="sm"
            variant="warning"
            @click="openLivnessModal"
          >
            Livness Check
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="secondary"
            @click="openLearningCenterBlockModal"
          >
            Learning Center Block
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'
import store from '@/store'
// import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BSpinner,
    // BFormCheckbox,
  },
  props: {
    viewdIn: {
      type: String,
      default: undefined,
    },
  },
  setup(_, ctx) {
    const isLicensed = computed(() => ctx.root.$store.getters['driverView/getLicenseStatus'])
    const fetchingLicenses = computed(() => ctx.root.$store.getters['driverView/getFetchingLicensesStatus'])
    const driverData = computed(() => store.getters['drivers/currentDriver'])
    const openSendNotificationModal = () => ctx.root.$bvModal.show('send-driver-notification-modal')
    const openSendAlertModal = () => ctx.root.$bvModal.show('send-alert-modal')
    const openLivnessModal = () => ctx.root.$bvModal.show('livness-check-modal')
    const openLearningCenterBlockModal = () => ctx.root.$bvModal.show('learning-center-block-modal')

    return {
      openLivnessModal,
      openSendNotificationModal,
      isLicensed,
      driverData,
      fetchingLicenses,
      openSendAlertModal,
      openLearningCenterBlockModal,
    }
  },
}
</script>

<style>

</style>
